import { getJSON, RSAA } from 'redux-api-middleware';
import { EmailPreviewSendRequest } from 'stageclip-common';

import { InternalActionTypes } from 'constants/actionTypes';
import { FetchEmailsTemplatesIds, FetchEmailTemplate } from './mails.types';

const FETCH_EMAILS_LOG_REQUEST = 'FETCH_EMAILS_LOG_REQUEST';
const FETCH_EMAILS_LOG_SUCCESS = 'FETCH_EMAILS_LOG_SUCCESS';
const FETCH_EMAILS_LOG_FAILURE = 'FETCH_EMAILS_LOG_FAILURE';

export const fetchEmailsLog = (page: number, pageSize: number) => ({
  [RSAA]: {
    types: [
      FETCH_EMAILS_LOG_REQUEST,
      {
        type: FETCH_EMAILS_LOG_SUCCESS,
        payload: (action: any, state: any, res: any) =>
          // @ts-ignore
          getJSON(res).then((json: any) => json),
        meta: {
          unwrapPayload: true,
        },
      },
      FETCH_EMAILS_LOG_FAILURE,
    ],
    endpoint: `/emails?page=${page}&pageSize=${pageSize}`,
    method: 'GET',
  },
});

const FETCH_EMAILS_TEMPLATES_IDS_REQUEST = 'FETCH_EMAILS_TEMPLATES_IDS_REQUEST';
const FETCH_EMAILS_TEMPLATES_IDS_SUCCESS = 'FETCH_EMAILS_TEMPLATES_IDS_SUCCESS';
const FETCH_EMAILS_TEMPLATES_IDS_FAILURE = 'FETCH_EMAILS_TEMPLATES_IDS_FAILURE';

export const fetchEmailsTemplatesIds: FetchEmailsTemplatesIds = eventId => ({
  [RSAA]: {
    types: [FETCH_EMAILS_TEMPLATES_IDS_REQUEST, FETCH_EMAILS_TEMPLATES_IDS_SUCCESS, FETCH_EMAILS_TEMPLATES_IDS_FAILURE],
    endpoint: `/emails/${eventId}/templates`,
    method: 'GET',
  },
});

const FETCH_EMAIL_TEMPLATE_REQUEST = 'FETCH_EMAIL_TEMPLATE_REQUEST';
const FETCH_EMAIL_TEMPLATE_SUCCESS = 'FETCH_EMAIL_TEMPLATE_SUCCESS';
const FETCH_EMAIL_TEMPLATE_FAILURE = 'FETCH_EMAIL_TEMPLATE_FAILURE';

export const fetchEmailTemplate: FetchEmailTemplate = (participantId, templateId) => ({
  [RSAA]: {
    types: [FETCH_EMAIL_TEMPLATE_REQUEST, FETCH_EMAIL_TEMPLATE_SUCCESS, FETCH_EMAIL_TEMPLATE_FAILURE],
    endpoint: `/participants/${participantId}/email-preview?templateId=${templateId}`,
    method: 'GET',
  },
});

const SEND_EMAIL_PREVIEW_REQUEST = 'SEND_EMAIL_PREVIEW_REQUEST';
const SEND_EMAIL_PREVIEW_SUCCESS = InternalActionTypes.EmailPrevievSent;
const SEND_EMAIL_PREVIEW_FAILURE = 'SEND_EMAIL_PREVIEW_FAILURE';

export const sendEmailPreview = (participantId: string, body: EmailPreviewSendRequest) => ({
  [RSAA]: {
    types: [SEND_EMAIL_PREVIEW_REQUEST, SEND_EMAIL_PREVIEW_SUCCESS, SEND_EMAIL_PREVIEW_FAILURE],
    endpoint: `/participants/${participantId}/email-preview-send`,
    method: 'POST',
    body,
  },
});

const FETCH_EVENT_EMAILS_LOG_REQUEST = 'FETCH_EVENT_EMAILS_LOG_REQUEST';
const FETCH_EVENT_EMAILS_LOG_SUCCESS = 'FETCH_EVENT_EMAILS_LOG_SUCCESS';
const FETCH_EVENT_EMAILS_LOG_FAILURE = 'FETCH_EVENT_EMAILS_LOG_FAILURE';

export const fetchEventEmailsLog = (eventId: string) => ({
  [RSAA]: {
    types: [FETCH_EVENT_EMAILS_LOG_REQUEST, FETCH_EVENT_EMAILS_LOG_SUCCESS, FETCH_EVENT_EMAILS_LOG_FAILURE],
    endpoint: `/emails/${eventId}/email-events`,
    method: 'GET',
  },
});
